import { useEffect, useState } from 'react';
import { rewriteAdvice } from '@/lib/llm/client';

/**
 * Versión en lenguaje natural de un aviso ya calculado (SPEC 8, uso 2).
 *
 * Se pinta SIEMPRE el texto del motor primero y solo se sustituye si llega una
 * reescritura válida. Así la pantalla nunca espera al LLM, y si este falla o
 * altera una cifra, el usuario ni se entera: sigue viendo la plantilla.
 */
export function useRewritten(message: string, enabled: boolean): string {
  const [rewritten, setRewritten] = useState<{ from: string; text: string } | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let alive = true;

    void rewriteAdvice(message).then((outcome) => {
      if (alive && outcome.available) setRewritten({ from: message, text: outcome.value });
    });

    return () => {
      alive = false;
    };
  }, [message, enabled]);

  // Si el aviso cambió desde que se pidió la reescritura, la vieja no vale.
  return enabled && rewritten?.from === message ? rewritten.text : message;
}
